// Import services
import services from 'services/services';

export const fetchGeoblockPurchase = async (): Promise<{ isLocationAvailable: boolean } | null> =>
	await services
		.get('/payments/country/isPurchaseAvailable')
		.then(({ data }) => ({ isLocationAvailable: Boolean(data.message) }))
		.catch(() => null);

export const fetchGeoblockWatch = async (): Promise<{ isLocationAvailable: boolean } | null> => {
	try {
		const {
			data: { message: isPolish }
		} = await services.get('/subscriber/inPoland');

		const {
			data: { message: isEOG }
		} = await services.get('/subscriber/inEog');

		if (!isPolish && !isEOG) {
			return { isLocationAvailable: false };
		}

		return { isLocationAvailable: true };
	} catch {
		return null;
	}
};
